<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-card class="elevation-12" v-show="!isLoggedIn()">
          <v-card-title>
            <h1>Please Login with Auth0 SSO</h1>
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click.stop="handleLogin()">Login</v-btn>
          </v-card-actions>
        </v-card>
        <v-card class="elevation-12" v-show="isLoggedIn()">
          <v-card-title>
            <h1>You Are Already Logged In</h1>
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" :to="{name: 'dashboard'}">Go To Dashboard</v-btn>
            <v-btn color="primary" @click.stop="handleLogout()">Logout</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { isLoggedIn, login, logout } from '../utils/auth';

export default {
  name: 'Sign In',
  methods: {
    handleLogin() {
      login();
    },
    handleLogout() {
      logout();
    },
    isLoggedIn() {
      return isLoggedIn();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
